/* eslint-disable jsx-a11y/label-has-for */

import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';
import {I18n} from 'react-redux-i18n';
import { Icon } from '@material-ui/core';

class BlurringSettings extends React.Component {
  constructor(props) {
    super(props);
  }
  handleChange = () => event => {
    this.props.onChange(event.target.checked);
  }

  render() {
    const { options, isMobile } = this.props;
    return (
      <React.Fragment>
        <div className="ondemand__blurring">
          <div className={`ondemand__blurring__label ${isMobile ? 'column' : ''} `}>
            <label>{I18n.t('page.admin.form.blurring.title')}</label>
            {isMobile ? <div className='ondemand__blurring__info'>({options.disabled ? I18n.t('page.onDemand.form.blurringDisabledInfo') : I18n.t('page.onDemand.form.blurringEnabledInfo')})</div> : <Tooltip title={options.disabled ? I18n.t('page.onDemand.form.blurringDisabledInfo') : I18n.t('page.onDemand.form.blurringEnabledInfo')}>
              <Icon>info</Icon>
            </Tooltip>}
          </div>
          <label htmlFor="blurring">
            <Checkbox id="blurring" onChange={this.handleChange()} checked={this.props.options.value} disabled={this.props.options.disabled}/>
          </label>
        </div>
      </React.Fragment>
    );
  }
}

export default BlurringSettings;
